export default __webpack_public_path__ + "images/imagite-stone-2.svg";